import { publicApi, api } from '@/api'

interface SendMessageRequest {
  prompt: string
}
export type ThreadedSendMessageRequest = SendMessageRequest & {
  threadId: string
}
interface SendMessageResponse {
  messageId: string
  threadId: string
  threadTitle: string
  message?: string
  tokens: {
    thread: number
    message: number
  }
}

export interface UnansweredQuestion {
  id: string
  question: string
  time: string
  resolved: boolean
  email: string | null
}

export const chatPublicApi = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    sendMessage: builder.mutation<SendMessageResponse, SendMessageRequest>({
      query: (data) => ({
        url: '/cmd/chat/send-message',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Chat'],
    }),
    sendMessageWithThread: builder.mutation<SendMessageResponse, ThreadedSendMessageRequest>({
      query: ({ threadId, ...body }) => ({
        url: `/cmd/chat/${threadId}/send-message`,
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['Chat'],
    }),
  }),
  overrideExisting: false,
})

export const { useSendMessageMutation, useSendMessageWithThreadMutation } = chatPublicApi

export const chatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUnansweredQuestions: builder.query<UnansweredQuestion[], void>({
      query: () => ({
        url: '/query/unanswered-questions/get-unanswered-questions',
        method: 'GET',
      }),
      providesTags: ['Chat'],
    }),
    resolveUnansweredQuestion: builder.mutation<void, string>({
      query: (id) => ({
        url: `/cmd/unanswered-questions/${id}/resolve-unanswered-question`,
        method: 'POST',
      }),
      invalidatesTags: ['Chat'],
    }),
    setBotStatus: builder.mutation<boolean, boolean>({
      query: (disabled) => ({
        url: '/cmd/chat/set-bot-status',
        method: 'POST',
        data: { disabled },
      }),
    }),
    getBotStatus: builder.query<{ disabled: boolean }, void>({
      query: () => ({
        url: '/query/chat/get-bot-status',
        method: 'GET',
      }),
    }),
  }),

  overrideExisting: false,
})

export const {
  useGetUnansweredQuestionsQuery,
  useResolveUnansweredQuestionMutation,
  useSetBotStatusMutation,
  useGetBotStatusQuery,
} = chatApi
